import file from './File';
import postback from './Postback';
import callto from './Callto';
import mailto from './Mailto';
import url from './Url';
import contentButton from './Content';
import location from './Location';

const allTypes = {
  file,
  callto,
  mailto,
  postback,
  url,
  contentButton,
  location
};

const types = {
  ...allTypes,
  all: [
    allTypes.callto,
    allTypes.mailto,
    allTypes.url,
    allTypes.file,
    allTypes.postback,
    allTypes.contentButton,
    allTypes.location
  ]
};

export default types;
